import { render } from "./ActivityComponent.vue?vue&type=template&id=207ac394&ts=true"
import script from "./ActivityComponent.vue?vue&type=script&lang=ts"
export * from "./ActivityComponent.vue?vue&type=script&lang=ts"

import "./ActivityComponent.vue?vue&type=style&index=0&id=207ac394&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__